module.exports = __webpack_public_path__ + "static/media/operations-main.5cb64c5f.svg";